let DoctorAppointment = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;

  this.SubmitDoctorAppointmentSchedule = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/DoctorAppointment/SubmitDoctorAppointmentSchedule";
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.CopyDoctorAppointmentScheduleToOtherDay = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/DoctorAppointment/CopyDoctorAppointmentScheduleToOtherDay";
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.RefuseOrder = function (orderNumber, refundReason, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/RefuseOrder/${orderNumber}/${refundReason}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.UpdateDoctorAppointmentSchedule = function (doctorId, item, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointment/UpdateDoctorAppointmentSchedule/${doctorId}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.DeleteDoctorAppointmentSchedule = function (doctorId, scheduleDate, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointment/DeleteDoctorAppointmentSchedule/${doctorId}/${scheduleDate}`;
    TokenClient.Post(
      url,
      null,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.CopyDoctorAppointmentSchedule = function (doctorId, sourceDate, destDate, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointment/CopyDoctorAppointmentSchedule/${doctorId}/${sourceDate}/${destDate}`;
    TokenClient.Post(
      url,
      null,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.OrderDetail = function (orderNumber, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/OrderDetail/${orderNumber}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetDoctorAppointmentScheduleListByDate = function (doctorId, date, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointment/GetDoctorAppointmentScheduleListByDate/${doctorId}/${date}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  /**
   *
   * @param {*} states  0 待支付 1 已付款(已预约) 2 已完成 -1 已取消 -2 已退号 -3 删除
   * @param {*} startTime
   * @param {*} endTime
   * @param {*} payType 全部-1 余额 0 微信 1 支付宝 2
   * @param {*} keyword
   * @param {*} pageIndex
   * @param {*} pageSize
   * @param {*} success
   * @param {*} error
   */
  this.GetOrganizationOrderList = function (states, startTime, endTime, payType, keyword, pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/DoctorAppointmentOrder/GetOrganizationOrderList/${states}`;
    if (startTime) {
      url += `/${startTime}`;
    } else {
      url += "/%20";
    }
    if (endTime) {
      url += `/${endTime}`;
    } else {
      url += "/%20";
    }
    url += `/${payType}`;
    if (keyword) {
      url += `/${keyword}/${pageIndex}`;
    } else {
      url += `/%20/${pageIndex}`;
    }

    if (pageSize) {
      url += `/${pageSize}`;
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  /**
   *
   * @param {*} states 0待支付 1已付款(待接诊) 2接诊中 3已完成 -1已取消 -2已退款 -3医生拒绝接诊 -4删除 -999全部订单
   * @param {*} startTime
   * @param {*} endTime
   * @param {*} orderType 1电话问诊 2在线问诊
   * @param {*} payType 全部-1 余额 0 微信 1 支付宝 2
   * @param {*} keyword
   * @param {*} pageIndex
   * @param {*} pageSize
   * @param {*} success
   * @param {*} error
   */
  this.GetOrgOrderList = function (states, startTime, endTime, orderType, payType, keyword, pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/GetOrganizationOrderList/${states}`;
    if (startTime) {
      url += `/${startTime}`;
    } else {
      url += "/%20";
    }
    if (endTime) {
      url += `/${endTime}`;
    } else {
      url += "/%20";
    }
    url += `/${orderType}/${payType}`;
    if (keyword) {
      url += `/${keyword}/${pageIndex}`;
    } else {
      url += `/%20/${pageIndex}`;
    }

    if (pageSize) {
      url += `/${pageSize}`;
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };

  this.GetOrganizationConsultationEvaluatePage = function (type, startTime, endTime, star, keyword, pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationEvaluate/GetOrganizationConsultationEvaluatePage/${type}`;
    if (startTime) {
      url += `/${startTime}`;
    } else {
      url += "/%20";
    }
    if (endTime) {
      url += `/${endTime}`;
    } else {
      url += "/%20";
    }
    url += `/${star}`;
    if (keyword) {
      url += `/${keyword}/${pageIndex}`;
    } else {
      url += `/%20/${pageIndex}`;
    }

    if (pageSize) {
      url += `/${pageSize}`;
    }
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.DoctorCompleteOrder = function (orderNumber, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/DoctorCompleteOrder/${orderNumber}`;
    TokenClient.Post(
      url,
      null,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };

  this.OrderInfo = function (orderNumber, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/OrderDetail/${orderNumber}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.ConfirmOrder = function (orderNumber, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/ConfirmOrder/${orderNumber}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.AbortOrder = function (orderNumber, refuseReson, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationOrder/AbortOrder/${orderNumber}/${refuseReson}`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.SubmitEvaluateReply = function (item, success, error) {
    var url = ServiceBaseAddress + "/api/ConsultationEvaluate/SubmitEvaluateReply";
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.DeleteEvaluate = function (id, success, error) {
    var url = ServiceBaseAddress + `/api/ConsultationEvaluate/DeleteEvaluate/${id}`;
    TokenClient.Post(
      url,
      null,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
};

export { DoctorAppointment };
